export default "__VITE_ASSET__CTSb_uF4__"